import { getApplyToSelection } from '@jane/business-admin/components/shared/specials/modal/form';
import type { SpecialRulesV2 } from '@jane/business-admin/types';
import { transformRules } from '@jane/business-admin/util';

// qualifier/discountable accept either a single ruleset (spending_threshold's native form)
// or an array of rulesets (bundle parity payload)
// coerce defensively in case an array slips through.
const firstRuleset = <T>(value: T | T[] | null | undefined): T | undefined =>
  Array.isArray(value) ? value[0] : (value ?? undefined);

export const convertSpendingThresholdToRules = (
  spendingRules: SpecialRulesV2
) => {
  if (spendingRules) {
    const qualifier = firstRuleset(spendingRules.qualifier);
    const discountable = firstRuleset(spendingRules.discountable);
    return {
      required_rules: {
        apply_to: getApplyToSelection(qualifier),
        rules: transformRules(qualifier || {}),
      },
      discounted_rules: {
        apply_to: getApplyToSelection(discountable),
        rules: transformRules(discountable || {}),
      },
    };
  }
  return;
};
